import { createBrowserRouter, Outlet, ScrollRestoration } from "react-router-dom";

import Home from "features/home/pages/Home";

import AccountCategoryList from "features/accountCategory/pages/AccountCategoryList";
import YearAccumulateList from "features/accumulate/pages/YearAccumulateList";
import AttendanceCreate from "features/attendance/pages/AttendanceCreate";
import AttendanceEdit from "features/attendance/pages/AttendanceEdit";
import AttendanceSetting from "features/attendance/pages/AttendanceSetting";
import LeaveTypeCreate from "features/attendance/pages/LeaveTypeCreate";
import LeaveTypeEdit from "features/attendance/pages/LeaveTypeEdit";
import ShiftsCreate from "features/attendance/pages/ShiftsCreate";
import ShiftsEdit from "features/attendance/pages/ShiftsEdit";
import ShiftsView from "features/attendance/pages/ShiftsView";
import ChangePassword from "features/authentication/pages/ChangePassword";
import ForgotPassword from "features/authentication/pages/ForgotPassword";
import Login from "features/authentication/pages/Login";
import ResetPassword from "features/authentication/pages/ResetPassword";
import SignUp from "features/authentication/pages/SignUp";
import CompanyProfile from "features/company/pages/CompanyProfile";
import CompanyProfileCreate from "features/company/pages/CompanyProfileCreate";
import CompanyProfileEdit from "features/company/pages/CompanyProfileEdit";
import CreateTemplateCreate from "features/createTemplate/pages/createTemplateCreate";
import Dashboard from "features/dashboard/page/Dashboard";
import Employee from "features/employee/pages/Employee";
import EmployeeCreate from "features/employee/pages/EmployeeCreate";
import EmployeeDocument from "features/employee/pages/EmployeeDocument";
import EmployeeEdit from "features/employee/pages/EmployeeEdit";
import EmployeeEmployment from "features/employee/pages/EmployeeEmployment";
import EmployeeInfo from "features/employee/pages/EmployeeInfo";

import EmployeeList from "features/employee/pages/EmployeeList";
import EmployeePerformance from "features/employee/pages/EmployeePerformance";
import EmployeeSalary from "features/employee/pages/EmployeeSalary";
import EmployeeWorkIn from "features/employee/pages/EmployeeWorkIn";
import MasterData from "features/masterData/pages/MasterData";
import MyRequest from "features/myDocument/pages/MyRequest";
import MyTeam from "features/myTeam/pages/MyTeam";
import MyTeamAttendance from "features/myTeam/pages/MyTeamAttendance";
import MyTeamCalendar from "features/myTeam/pages/MyTeamCalendar";
import MyTeamLeaveBenefit from "features/myTeam/pages/MyTeamLeaveBenefit";
import MyTeamManageShift from "features/myTeam/pages/MyTeamManageShift";
import MyTeamTimestamp from "features/myTeam/pages/MyTeamTimestamp";
import MyTeamWorkingInformation from "features/myTeam/pages/MyTeamWorkingInformation";
import MyTeamWorkSchedule from "features/myTeam/pages/MyTeamWorkSchedule";
import NewsCreate from "features/newAndPolicy/page/NewsCreate";
import NewsEdit from "features/newAndPolicy/page/NewsEdit";
import NewsList from "features/newAndPolicy/page/NewsList";
import PolicyCreate from "features/newAndPolicy/page/PolicyCreate";
import PolicyEdit from "features/newAndPolicy/page/PolicyEdit";
import PolicyList from "features/newAndPolicy/page/PolicyList";
import PayrollSetting from "features/payrollSetting/pages/PayrollSetting";

import EmploymentType from "features/payrollSetting/pages/EmploymentType";
import PayrollDeduction from "features/payrollSetting/pages/PayrollDeduction";
import PayrollDeductionCreate from "features/payrollSetting/pages/PayrollDeductionCreate";
import PayrollDeductionEdit from "features/payrollSetting/pages/PayrollDeductionEdit";
import PayrollIncome from "features/payrollSetting/pages/PayrollIncome";
import PayrollCreate from "features/payrollSetting/pages/PayrollIncomeCreate";
import PayrollEdit from "features/payrollSetting/pages/PayrollIncomeEdit";
import PayrollWelfare from "features/payrollSetting/pages/PayrollWelfare";
import PayrollWelfareCreate from "features/payrollSetting/pages/PayrollWelfareCreate";
import PayrollWelfareEdit from "features/payrollSetting/pages/PayrollWelfareEdit";



import NotFound from "features/notfound/pages/NotFound";
import PayrollPeriodPage from "features/payroll/page/PayrollPeriod";
import PayrollPeriodCreatePage from "features/payroll/page/PayrollPeriodCreate";
import RequestApproval from "features/requestApproval/pages/RequestApproval";
import SettingPage from "features/settingEemailNotification/pages/SettingPage";
import SocialSecurityContribution from "features/socialSecurityContribution/page/SocialSecurityContribution";
import UserList from "features/userManagement/pages/UserList";
import UserManagement from "features/userManagement/pages/UserManagement";
import UserPayrollPermission from "features/userManagement/pages/UserPayrollPermission";
import UserPermission from "features/userManagement/pages/UserPermission";
import UserRole from "features/userManagement/pages/UserRole";
// import EmployeeInfoGeneralInfo from "features/employee/pages/EmployeeInfoGeneralInfo";
import EmployeeInfoGeneralInfoPage from "features/employee/pages/EmployeeInfoGeneralInfoPage";
import MenuPage from "features/webapp/page/MenuPage";
import PolicyPage from "features/webapp/page/PolicyPage";
import ProductPage from "features/webapp/page/ProductPage";
import WebappPage from "features/webapp/page/WebappPage";


import AllNewsList from "features/newAndPolicy/page/AllNewsList";
import NewsView from "features/newAndPolicy/page/NewsView";
import PaymentPage from "features/payment/page/PaymentPage";
import ProductManagePage from "features/product/page/ProductManagePage";
import EmployeeHistoryGroup from "features/Report/pages/EmployeeHistoryGroupPage";
import LeaveRightsGroup from "features/Report/pages/LeaveRightsGroupPage";
import Report from "features/Report/pages/ReportPage";
import SalaryCalculationGroup from "features/Report/pages/SalaryCalculationGroupPage";
import WorkingTimeGroup from "features/Report/pages/WorkingTimeGroupPage";
import ProductManagementEdit from "features/product/components/ProductManagementEdit";
import LeaveRightsPage from "features/Report/pages/leaveRightsGroup/LeaveRightsPage";
import WorkTimeReportPage from "features/Report/pages/workTimeGroup/WorkTimeReportPage";
import EmployeePayrollReportPage from "features/Report/pages/salaryGroup/EmployeeSalaryPayrollPage";
import CompletePage from "features/webapp/page/CompletePage";
import COnsentPage from "features/webapp/page/ConsentPage";
import DetailPage from "features/webapp/page/DetailPage";
import HistoryPage from "features/webapp/page/HistoryPage";
import OtpPage from "features/webapp/page/OtpPage";
import TransactionPage from "features/webapp/page/TransactionPage";
import UserPage from "features/webapp/page/UserPage";
import VerifyPage from "features/webapp/page/VerifyPage";
import BeCashBackOfficePage from "features/whiteList/page/BeCashBackofficePage";
import WhiteListPage from "features/whiteList/page/WhiteListPage";
import CompanyConfigMail from "features/company/pages/CompanyConfigMail";
import MyTeamSubordinatePage from "features/myTeam/pages/MyTeamSubordinatePage";
import OvertimeReportPage from "features/Report/pages/salaryGroup/OvertimeReportPage";
import Section50BisPage from "features/Report/pages/salaryGroup/Section50BisReportPage";
import PND1ReportPage from "features/Report/pages/salaryGroup/PND1ReportPage";
import PND1KorReportPage from "features/Report/pages/salaryGroup/PND1KorReportPage";
import PND3ReportPage from "features/Report/pages/salaryGroup/PND3ReportPage";
import EmployeeWarningLetter from "features/Report/pages/EmployeeWarningLetterPage";
import TerminateSocialSecurityReportPage from "features/Report/pages/employeeHistoryGroup/TerminateSocialSecurityReportPage";
import EmployeeWelfarePage from "features/employee/pages/EmployeeWelfare";
import AnnualPND1ReportPage from "features/Report/pages/salaryGroup/AnnualPND1ReportPage";
import SSOPaymentReportPage from "features/Report/pages/salaryGroup/SSOPaymentReportPage";
import CreateNotifySettingPage from "features/settingEemailNotification/pages/CreateNotifySettingPage";
import EmployeeRegisterUnderLabourReportPage from "features/Report/pages/employeeHistoryGroup/EmployeeRegisterUnderLabourReportPage";
import WorkingAbsencePage from "features/Report/pages/WorkingAbsencePage";
import SettingTimesheetProjectPage from "features/settingTimesheet/pages/SettingTimesheetProjectPage";
import SettingTimesheetMasterPage from "features/settingTimesheet/pages/SettingTimesheetMasterPage";
import SettingTimesheetCreateRolePage from "features/settingTimesheet/pages/SettingTimesheetCreateRolePage";
import SettingTimesheetCreateWorkPage from "features/settingTimesheet/pages/SettingTimesheetCreateWorkPage";
import SettingTimesheetEditeRolePage from "features/settingTimesheet/pages/SettingTimeSheetEditRolePage";
import SettingTimesheetEditRolePage from "features/settingTimesheet/pages/SettingTimeSheetEditRolePage";
import CreateSettingProjectPage from "features/settingTimesheet/pages/CreateSettingProjectPage";
import EditSettingProjectPage from "features/settingTimesheet/pages/EditSettingProjectPage";
import MyTimesheetPage from "features/myTimesheet/pages/MyTimesheetPage";
import UpdateMyTimesheetPage from "features/myTimesheet/pages/UpdateMyTimesheetPage";
import ViewSettingProjectPage from "features/settingTimesheet/pages/ViewSettingProjectPage";
import AdminCompanyPage from "features/adminCompany/pages/Admin";
import AdminDetailPage from "features/adminCompany/pages/AdminDetail";
import AdminLoginPage from "features/authentication/pages/AdminLoginPage";
import AdminPaymentHistoryPage from "features/adminCompany/pages/AdminPaymentHistoryPage";
import AdminCreateCompanyPage from "features/adminCompany/pages/AdminCreateCompanyPage";
import CompanyImportDataPage from "features/company/pages/CompanyImportDataPage";
import MyTeamPage from "features/myTimesheet/pages/TeamPage";
import ExpensePage from "features/Expense/pages/ExpensePage";
import ExpenseMainPage from "features/Expense/pages/ExpenseMainPage";
import MyTeamLeaveCalendarPage from "features/myTeam/pages/MyTeamLeaveCalendarPage";
import AdminCompanyPackageDetail from "features/adminCompany/components/AdminCompanyPackageDetail";
import AdminSetting from "features/adminPermission/components/AdminSetting";
import AdminCampaigsPromotions from "features/adminCampaignsPromotions/components/AdminCampaigsPromotions";
import WorkingExpensePage from "features/Report/pages/WorkingExpansePage";
import GroupCalculationPage from "features/payment/page/GroupCalculationPage";
import WarningLetterRequestPage from "features/WarningLetter/pages/WarningLetterRequestPage";
import FundFormPage from "features/fund/pages/FundFormPage";
import FundList from "features/fund/pages/FundList";
import EmployeeFundPage from "features/employeeFund/pages/EmployeeFundPage";
import SettingEmailNotificationPage from "features/settingEmailTemplate/pages/SettingEmailNotificationPage";
import SettingEmailTemplateForm from "features/settingEmailTemplate/pages/SettingEmailTemplateForm";
import FundReportPage from "features/Report/pages/salaryGroup/FundReportPage";

const RootLayout = () => {
  return (
    <>
      <Outlet />
      <ScrollRestoration />
    </>
  );
};

const router = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      // {
      //   path: "/",
      //   element: <Home />,
      //   errorElement: <NotFound />,
      // },
      {
        path: "/login",
        element: <Login />,
      },
      {
        path: "/admin/login",
        element: <AdminLoginPage />,
      },
      {
        path: "/sign_up",
        element: <SignUp />,
      },
      {
        path: "/forgot_password",
        element: <ForgotPassword />,
      },
      {
        path: "/resetPassword",
        element: <ResetPassword />,
      },
      {
        path: "/change_password",
        element: <ChangePassword />,
      },
      {
        path: "/my_team",
        element: <MyTeam />,
        children: [
          {
            path: "working_information",
            element: <MyTeamWorkingInformation />,
          },
          {
            path: "work_schedule",
            element: <MyTeamWorkSchedule />,
          },
          {
            path: "workin_calendar",
            element: <MyTeamCalendar />,
          },
          {
            path: "leave_calendar",
            element: <MyTeamLeaveCalendarPage />,
          },
          {
            path: "manage_shift",
            element: <MyTeamManageShift />,
          },
          {
            path: "timestamp",
            element: <MyTeamTimestamp />,
          },
          {
            path: "attendance",
            element: <MyTeamAttendance />,
          },
          {
            path: "leave_benefit",
            element: <MyTeamLeaveBenefit />,
          },
          {
            path: "subordinate",
            element: <MyTeamSubordinatePage />
          }
        ],
      },
      {
        path: "/timesheet/my_timesheet",
        element: <MyTimesheetPage />,
      },
      {
        path: "/timesheet/my_team",
        element: <MyTeamPage />,
      },
      {
        path: "/my_document/my_request",
        element: <MyRequest />,
      },
      {
        path: "/my_document/request_approval",
        element: <RequestApproval />,
      },
      {
        path: "/my_document/warning_letter",
        element: <WarningLetterRequestPage />,
      },
      {
        path: "/employee",
        element: <Employee />,
        children: [
          {
            index: true,
            element: <EmployeeList />,
          },
          {
            path: "create",
            element: <EmployeeCreate />,
          },
          {
            path: ":id",
            element: <EmployeeEdit />,
            children: [
              {
                path: "employee_info",
                element: <EmployeeInfo />,
              },
              {
                path: "employment",
                element: <EmployeeEmployment />,
              },
              {
                path: "workin",
                element: <EmployeeWorkIn />,
              },
              {
                path: "performance",
                element: <EmployeePerformance />,
              },
              {
                path: "document",
                element: <EmployeeDocument />,
              },
              {
                path: "salary",
                element: <EmployeeSalary />,
              },
              {
                path: "welfare",
                element: <EmployeeWelfarePage />
              },
              {
                path: "employeeFund",
                element: <EmployeeFundPage />,
              },
            ],
          },
        ],
      },
      {
        path: "/webapp",
        element: <WebappPage />,
        children: [
          {
            index: true,
            element: <MenuPage />,
          },
          {
            path: "policy",
            element: <PolicyPage />,
          },
          {
            path: "product",
            element: <ProductPage />,
          },
          {
            path: "detail",
            element: <DetailPage />,
          },
          {
            path: "transaction",
            element: <TransactionPage />,
          },
          {
            path: "verify",
            element: <VerifyPage />,
          },
          {
            path: "consent",
            element: <COnsentPage />,
          },
          {
            path: "otp",
            element: <OtpPage />,
          },
          {
            path: "complete",
            element: <CompletePage />,
          },
          {
            path: "history",
            element: <HistoryPage />,
          },
          {
            path: "user",
            element: <UserPage />,
          },
        ],
      },
      {
        path: "/configuration/company",
        element: <CompanyProfile />,
      },
      {
        path: "/configuration/company/create",
        element: <CompanyProfileCreate />,
      },
      {
        path: "/configuration/company/:id/edit",
        element: <CompanyProfileEdit />,
      },
      {
        path: "/configuration/payroll/fundPage",
        element: <FundList />,
      },

      {
        path: "/configuration/payroll/fund/create",
        element: <FundFormPage />,
      },
      {
        path: "/configuration/payroll/fund/view/:id",
        element: <FundFormPage />,
      },
      {
        path: "/configuration/payroll/fund/edit/:id",
        element: <FundFormPage />,
      },
      {
        path: "/news_policy/policy",
        element: <PolicyList />,
      },
      {
        path: "/news_policy/policy/create",
        element: <PolicyCreate />,
      },
      {
        path: "/news_policy/policy/:id/edit",
        element: <PolicyEdit />,
      },

      {
        path: "/admin/create_company",
        element: <AdminCreateCompanyPage />,
      },
      {
        path: "/admin/response_company",
        element: <AdminCompanyPage />,
      },


      {
        path: "/admin/admin_campaigns_promotions",
        element: <AdminCampaigsPromotions />,
      },
      {
        path: "/admin/admin_setting",
        element: <AdminSetting />,
      },

      {
        path: "/admin/response_company/comapany_info",
        element: <AdminDetailPage />,
      },
      {
        path: "/admin/response_company/payment_history",
        element: <AdminPaymentHistoryPage />,
      },

      {
        path: "/admin/response_company/package_detail",
        element: <AdminCompanyPackageDetail />,
      },

      {
        path: "/news_policy/news",
        element: <NewsList />,
      },
      {
        path: "/news_policy/news/create",
        element: <NewsCreate />,
      },
      {
        path: "/news_policy/news/:id/edit",
        element: <NewsEdit />,
      },
      {
        path: "/news_list",
        element: <AllNewsList />,
      },
      {
        path: "/news_list/view",
        element: <NewsView />
      },
      {
        path: "/masterdata/master_data",
        element: <MasterData />,
      },
      // {
      //   path: "/configuration/payroll/income",
      //   element: <PayrollIncome />,
      // },
      // {
      //   path: "/configuration/payroll/income/create",
      //   element: <PayrollCreate />,
      // },
      // {
      //   path: "/configuration/payroll/income/:id/edit",
      //   element: <PayrollEdit />,
      // },
      // {
      //   path: "/configuration/payroll/employment_type_setup",
      //   element: <EmploymentType />
      // },
      // {
      //   path: "/configuration/payroll/deduction",
      //   element: <PayrollDeduction />,
      // },
      // {
      //   path: "/configuration/payroll/deduction/create",
      //   element: <PayrollDeductionCreate />,
      // },
      // {
      //   path: "/configuration/payroll/deduction/:id/edit",
      //   element: <PayrollDeductionEdit />,
      // },
      // {
      //   path: "/configuration/payroll/welfare",
      //   element: <PayrollWelfare />,
      // },

      // {
      //   path: "/configuration/payroll/welfare/create",
      //   element: <PayrollWelfareCreate />,
      // },
      // {
      //   path: "/configuration/payroll/welfare/:id/edit",
      //   element: <PayrollWelfareEdit />,
      // },
      {
        path: "/payroll/create",
        element: <PayrollPeriodCreatePage />
      },
      {
        path: "/payroll",
        element: <PayrollPeriodPage />,
      },
      {
        path: "/configuration/attendance",
        element: <AttendanceSetting />,
      },
      {
        path: "/configuration/payroll",
        element: <PayrollSetting />,

      },
      {
        path: "/configuration/payroll/income",
        element: <PayrollIncome />,
      },
      {
        path: "/configuration/payroll/income/create",
        element: <PayrollCreate />,
      },
      {
        path: "/configuration/payroll/income/:id/edit",
        element: <PayrollEdit />,
      },
      {
        path: "/configuration/payroll/employment_type_setup",
        element: <EmploymentType />
      },
      {
        path: "/configuration/payroll/deduction",
        element: <PayrollDeduction />,
      },
      {
        path: "/configuration/payroll/deduction/create",
        element: <PayrollDeductionCreate />,
      },
      {
        path: "/configuration/payroll/deduction/:id/edit",
        element: <PayrollDeductionEdit />,
      },
      {
        path: "/configuration/payroll/welfare",
        element: <PayrollWelfare />,
      },

      {
        path: "/configuration/payroll/welfare/create",
        element: <PayrollWelfareCreate />,
      },
      {
        path: "/configuration/payroll/welfare/:id/edit",
        element: <PayrollWelfareEdit />,
      },
      {
        path: "/configuration/attendance/create",
        element: <AttendanceCreate />,
      },
      {
        path: "/configuration/attendance/edit",
        element: <AttendanceEdit />,
      },
      {
        path: "/configuration/attendance/leave_type/create",
        element: <LeaveTypeCreate />,
      },
      {
        path: "/configuration/attendance/leave_type/:id/:type",
        element: <LeaveTypeEdit />,
      },
      {
        path: "/configuration/attendance/shift/create",
        element: <ShiftsCreate />,
      },
      {
        path: "/configuration/attendance/shift/:id/edit",
        element: <ShiftsEdit />,
      },
      {
        path: "/configuration/attendance/shift/:id/view",
        element: <ShiftsView />,
      },
      {
        path: "/user_management",
        element: <UserManagement />,
        children: [
          {
            path: "user_list",
            element: <UserList />,
          },
          {
            path: "role",
            element: <UserRole />,
          },
          {
            path: "permission",
            element: <UserPermission />,
          },
          {
            path: "payroll_permission",
            element: <UserPayrollPermission />,
          },
        ],
      },
      {
        path: "/masterdata/social_security_contribution",
        element: <SocialSecurityContribution />,
      },
      {
        path: "/masterdata/year-to-date_earning",
        element: <YearAccumulateList />,
      },
      {
        path: "/masterdata/account_category",
        element: <AccountCategoryList />,
      },
      {
        path: "/masterdata/setting_notification",
        element: <SettingPage />,
      },
      {
        path: "/masterdata/setting_notification/create_notify",
        element: <CreateNotifySettingPage />,
      },
      {
        path: "/masterdata/setting_email_template",
        element: <SettingEmailNotificationPage />,
      },
      {
        path: "/masterdata/setting_email_template/create",
        element: <SettingEmailTemplateForm />,
      },
      {
        path: "/masterdata/setting_email_template/:id/edit",
        element: <SettingEmailTemplateForm />,
      },
      {

        path: "/masterdata/notification_template",
        element: <CreateTemplateCreate />
      },
      {
        path: "/masterdata/import_data",
        element: <CompanyImportDataPage />
      },
      {
        path: "/dashboard",
        element: <Dashboard />,
      },
      {
        path: "/expense",
        element: <ExpenseMainPage />,
      },
      {
        path: "/profile/:id",
        element: <EmployeeInfoGeneralInfoPage />,
      },
      {
        path: "/becash",
        element: <BeCashBackOfficePage />
      },
      {
        path: "/configuration/whitelist",
        element: <WhiteListPage />
      },
      {
        path: "/configuration/product",
        element: <ProductManagePage />,
      },
      {
        path: "/payroll/payment/:id",
        element: <PaymentPage />,
      },
      {
        path: "/payroll/payment/group_calculation/:id",
        element: <GroupCalculationPage />,
      },
      {
        path: "/report",
        element: <Report />,
        children: [
          {
            path: "/report/employee_history_group/employee_registration_report",
            element: <EmployeeHistoryGroup />,
          },
          {
            path: "/report/employee_history_group/employee_register_under_labour_act_report",
            element: <EmployeeRegisterUnderLabourReportPage />,
          },
          {
            path: "/report/employee_history_group/employee_warning_letter",
            element: <EmployeeWarningLetter />,
          },
        ],
      },
      {
        path: "report/employee_history_group/terminate_social_security_report",
        element: <TerminateSocialSecurityReportPage />
      },
      {
        path: "/report/salary_calculation_group/salary_calculation_normal_period",
        element: <SalaryCalculationGroup />,
      },
      {
        path: "/report/working_time_group/time_stamp",
        element: <WorkingTimeGroup />,
      },
      {
        path: "/report/working_time_group/absence",
        element: <WorkingAbsencePage />,
      },
      {
        path: "/report/expense_group/expense",
        element: <WorkingExpensePage />,
      },
      {
        path: "/report/leave_rights_group/leave_static",
        element: <LeaveRightsGroup />,
      },
      {
        path: "/report/leave_rights_group/leave_rights",
        element: <LeaveRightsPage />,
      },
      {
        path: "/report/working_time_group/work_in",
        element: <WorkTimeReportPage />,
      },
      {
        path: "/report/salary_calculation_group/employee_payroll_report",
        element: <EmployeePayrollReportPage />
      },
      {
        path: "report/working_time_group/overtime_report",
        element: <OvertimeReportPage />
      },
      {
        path: "/report/salary_calculation_group/section_50bis_report",
        element: <Section50BisPage />
      },
      {
        path: "report/salary_calculation_group/pnd1",
        element: <PND1ReportPage />
      },
      {
        path: "report/salary_calculation_group/pnd1kor",
        element: <PND1KorReportPage />
      },
      {
        path: "report/salary_calculation_group/annual_pnd_1",
        element: <AnnualPND1ReportPage />
      },
      {
        path: "report/salary_calculation_group/pnd3",
        element: <PND3ReportPage />
      },
      {
        path: "report/salary_calculation_group/sso_payment",
        element: <SSOPaymentReportPage />
      },
      {
        path: "report/salary_calculation_group/fund_report",
        element: <FundReportPage />
      },
      {
        path: "/masterdata/configuration_mail",
        element: <CompanyConfigMail />
      },
      {
        path: "/setting_timesheet/setting_project",
        element: <SettingTimesheetProjectPage />
      },
      {
        path: "/setting_timesheet/setting_project/create",
        element: <CreateSettingProjectPage />
      },
      {
        path: "/setting_timesheet/setting_project/edit/:id",
        element: <EditSettingProjectPage />
      },
      {
        path: "/setting_timesheet/setting_project/view/:id",
        element: <ViewSettingProjectPage />
      },
      {
        path: "/setting_timesheet/masterdata",
        element: <SettingTimesheetMasterPage />
      },
      {
        path: "/setting_timesheet/masterdata/create_role",
        element: <SettingTimesheetCreateRolePage />
      },
      {
        path: "/setting_timesheet/masterdata/edit_role",
        element: <SettingTimesheetEditRolePage />
      },
      {
        path: "/setting_timesheet/masterdata/create_task",
        element: <SettingTimesheetCreateWorkPage />
      },
    ],
    errorElement: <NotFound />,
  },
]);

export default router;
